
import API_ROUTES from "../constants/api";
import { ReportPageType, ReportSection } from "../constants/common";
import htmlDocx from 'html-docx-js/dist/html-docx';
import html2pdf from 'html2pdf.js';
import Utils from "./Utils";
import coverImg from '../../images/Cover-image-1-1280x720.jpg'
import logo from '../../images/Ecodrisil_logo.png'
import { normalizeLanguageCode, getTranslation } from "./TranslationHelpers";
import { buildCoverMetadataTableHtml } from "./reportCoverMetadataHtml";
import { buildIconGridTocHtml, escapeTocHtml } from "./reportTocWordHtml";
const allowedTypes = ['SINGLE_VALUE', 'TYPE_1_TABLE', 'TYPE_2_TABLE', 'TYPE_3_TABLE', 'TYPE_5_TABLE'];


const BASE_URL_DOMAIN = process.env.REACT_APP_ENV === 'esgx'
  ? `${window.location.protocol}//${window.location.host}/esgx`
  : `${window.location.protocol}//${window.location.host}`;

const qAnserData = (answer) => {
  if (!answer) return '';
  
  const formatValue = (value) => {
    // Convert to string to preserve decimal precision
    const valueStr = String(value);
    
    // Check if the value contains a decimal point
    if (valueStr.includes('.')) {
      // Split into integer and decimal parts
      const parts = valueStr.split('.');
      const integerPart = parts[0];
      const decimalPart = parts[1];
      
      // Check if all decimal digits are zeros
      if (decimalPart && /^0+$/.test(decimalPart)) {
        // All decimals are zeros, return just the integer part
        return integerPart;
      }
      
      // Has meaningful decimals, return as-is (preserving precision)
      return valueStr;
    }
    
    // No decimal point, return as-is
    return valueStr;
  };
  
  if (!!answer.uom) {
    if (answer.uom == "no.") {
      return parseInt(answer.value);
    } else {
      const formattedValue = formatValue(answer.value);
      return formattedValue + ' ' + answer.uom;
    }
  }
  return formatValue(answer.value);
}

/**
 * Matches template language code with report language code
 * Handles case-insensitive comparison and matches "EN" with "en-uk", "en-us", etc.
 * @param {string} templateLangCode - Language code from template data (e.g., "EN", "DE", "AR")
 * @param {string} reportLangCode - Language code from report (e.g., "en-uk", "en-us", "de")
 * @returns {boolean} True if codes match
 */
const matchesLanguageCode = (templateLangCode, reportLangCode) => {
  if (!templateLangCode || !reportLangCode) return false;
  
  // Normalize report language code (e.g., "en-uk" -> "en", "de" -> "de")
  const normalizedReportLang = normalizeLanguageCode(reportLangCode);
  
  // Extract base language from template code (e.g., "EN" -> "en", "DE" -> "de")
  // Handle both "EN" and "EN-UK" formats
  const templateLangLower = templateLangCode.toLowerCase();
  const baseTemplateLang = templateLangLower.split('-')[0];
  
  // Compare normalized codes (case-insensitive)
  return baseTemplateLang === normalizedReportLang;
}

const pageHeaderFunction = (templatedata, lang, type) => {
  let findLangValue = templatedata.localization.find(data => matchesLanguageCode(data.languageCode, lang))
  if (!findLangValue) {
    findLangValue = templatedata.localization.find(data => matchesLanguageCode(data.languageCode, 'en'))
  }
  if (!!findLangValue) {
    if (type == 'Social') {
      return (`<h4 style="margin-left: 20px;"><span style="font-size: 32px; color: #007bff;"><strong>${findLangValue.text}</strong></h4>
      <div style="font-family: Arial, sans-serif;line-height: 1.6;margin-left: 20px;">`)
    } else if (type == 'Governance') {
      return (`<h4 style="margin-left: 20px;"><span style="font-size: 32px; color: #f7c300;"><strong>${findLangValue.text}</strong></h4>
      <div style="font-family: Arial, sans-serif;line-height: 1.6;margin-left: 20px;">`)
    } else {
      return (`<h4 style="margin-left: 20px;"><span style="font-size: 32px; color: rgb(45, 194, 107);"><strong>${findLangValue.text}</strong></h4>
      <div style="font-family: Arial, sans-serif;line-height: 1.6;margin-left: 20px;">`)
    }
  } else {
    return ''
  }
}

const pageSectionFunction = (templatedata, lang) => {
  let findLangValue = templatedata.localization.find(data => matchesLanguageCode(data.languageCode, lang))
  if (!findLangValue) {
    findLangValue = templatedata.localization.find(data => matchesLanguageCode(data.languageCode, 'en'))
  }
  if (!!findLangValue) {
    return (`<h5 style='font-size:24px;margin:0px 0px 12px 0px;font-weight: 700;'>${findLangValue.text}</h5>`)
  } else {
    return ''
  }
}

const pageSubSectionFunction = (templatedata, lang, type) => {
  let findLangValue = templatedata.localization.find(data => matchesLanguageCode(data.languageCode, lang))
  if (!findLangValue) {
    findLangValue = templatedata.localization.find(data => matchesLanguageCode(data.languageCode, 'en'))
  }
  if (!!findLangValue) {
    return (`<h6 style='font-size: 20px;margin:0px 0px 16px 0px;font-weight: 600;'>${findLangValue.text}</h6>`)
  } else {
    return ''
  }
}

const pageQuestionFunction = (templatedata, lang) => {
  let findLangValue = templatedata.localization.find(val => matchesLanguageCode(val.languageCode, lang))
  if (!findLangValue) {
    findLangValue = templatedata.localization.find(val => matchesLanguageCode(val.languageCode, 'en'))
  }
  if (!!findLangValue) {
    return (
      `<div style="margin-bottom: 12px;font-size:14px;"><span style="color: rgb(52, 73, 94);"><strong>${findLangValue.text}</strong></span></div>
    <div style="margin-bottom: 16px;font-size:14px;text-align: justify;" class='${templatedata.key}'><span style="color: rgb(0, 0, 0);">${!!templatedata.keyValues && templatedata.keyValues.length > 0 ? qAnserData(templatedata.keyValues[0]) : ""}</span></div>`
    )
  } else {
    return ""
  }
}

const pagetableTYPE_1Function = (templatedata, lang) => {
  var contentHtml = ''
  let findLangValue = templatedata.localization.find(val => matchesLanguageCode(val.languageCode, lang))
  if (!findLangValue) {
    findLangValue = templatedata.localization.find(val => matchesLanguageCode(val.languageCode, 'en'))
  }
  if (!!findLangValue) {
    contentHtml += `<div style="margin-bottom: 10px;font-size:14px;margin-left: 20px;"><span style="color: rgb(52, 73, 94);"><strong>${findLangValue.text}</strong></span></div>`
  }
  contentHtml += `<div style="margin: 10px 20px;">
    <table style='width:100%;font-size:14px;border-collapse: collapse; border-spacing: 0;'>
      <thead><tr style="background-color: rgb(53, 152, 219); height: 20px;">`
  const columnHeaders = {};
  const filterTopHeader = templatedata.metadata.filter(item => /^[A-Z]1$/.test(item.columnNumber) && item.columnType === "HEADER");
  filterTopHeader.forEach(item => {
    let findLangValue = item.localization.find(val => matchesLanguageCode(val.languageCode, lang))
    if (!findLangValue) {
      findLangValue = item.localization.find(val => matchesLanguageCode(val.languageCode, 'en'))
    }
    if (!!findLangValue) {
      contentHtml += `<th style="border: 1px solid rgb(204, 204, 204); padding: 10px; text-align: left;width:${100 / filterTopHeader.length}%;"><span style="color: rgb(236, 240, 241);">${findLangValue.text}</span></th>`
    }
    columnHeaders[item.columnNumber.replace("1", "")] = item.columnNumber;
  })

  contentHtml += `</tr></thead><tbody>`
  const groupedRows = {};
  templatedata.keyValues.forEach((item) => {
    const col = item?.metadata?.columnNumber?.charAt(0);
    if (!!col) {
      if (!groupedRows[col]) groupedRows[col] = [];
      groupedRows[col].push(item);
    }
  });
  const maxRows = Math.max(...Object.values(groupedRows).map(arr => arr.length), 0);

  for (let i = 0; i < maxRows; i++) {
    contentHtml += `<tr style="height: 20px;">`

    Object.keys(columnHeaders).forEach(col => {
      contentHtml += `<td style="border: 1px solid rgb(204, 204, 204); padding: 10px; text-align: left; height: 20px;font-size:14px" class='${groupedRows[col]?.[i]?.key}'><span style="color: rgb(0, 0, 0);">${!!groupedRows[col]?.[i] ? qAnserData(groupedRows[col]?.[i]) : ""}</span></td>`
    });

    contentHtml += `</tr>`
  }
  contentHtml += `</tbody></table></div>`
  return contentHtml
}


const pagetableTYPE_2Function = (templatedata, lang) => {
  var contentHtml = ''
  let findLangValue = templatedata.localization.find(val => matchesLanguageCode(val.languageCode, lang))
  if (!findLangValue) {
    findLangValue = templatedata.localization.find(val => matchesLanguageCode(val.languageCode, 'en'))
  }
  if (!!findLangValue) {
    contentHtml += `<div style="margin-bottom: 10px;font-size:14px;margin-left: 20px;"><span style="color: rgb(52, 73, 94);"><strong>${findLangValue.text}</strong></span></div>`
  }
  contentHtml += `<div style="margin: 10px 20px;">
  <table style='width:100%;font-size:14px;border-collapse: collapse; border-spacing: 0;'><thead><tr style="background-color: rgb(53, 152, 219); height: 20px;">`
  const columnHeaders = {};
  const filterTopHeader = templatedata.metadata.filter(item => /^[A-Z]1$/.test(item.columnNumber) && item.columnType === "HEADER");
  filterTopHeader.forEach(item => {
    let findLangValue = item.localization.find(val => matchesLanguageCode(val.languageCode, lang))
    if (!findLangValue) {
      findLangValue = item.localization.find(val => matchesLanguageCode(val.languageCode, 'en'))
    }
    if (!!findLangValue) {
      contentHtml += `<th style="border: 1px solid rgb(204, 204, 204); padding: 10px; text-align: left;width:${100 / filterTopHeader.length}%;font-weight:800;font-size:16px;"><span style="color: rgb(236, 240, 241);">${findLangValue.text}</span></th>`
    }
    columnHeaders[item.columnNumber.replace("1", "")] = item.columnNumber;
  })

  contentHtml += `</tr></thead><tbody>`
  const groupedRows = {};
  const filterBody = templatedata.metadata.filter(meta => !/^[A-Z]1$/.test(meta.columnNumber));
  filterBody.forEach((item) => {
    const col = item?.columnNumber?.charAt(0);
    if (!!col) {
      if (!groupedRows[col]) groupedRows[col] = [];
      groupedRows[col].push(item);
    }
  });
  const maxRows = Math.max(...Object.values(groupedRows).map(arr => arr.length), 0);

  for (let i = 0; i < maxRows; i++) {
    contentHtml += `<tr style="height: 20px;">`

    Object.keys(columnHeaders).forEach(col => {
      const element = groupedRows[col]?.[i]
      if (!!element) {
        let findLangV = element?.localization.find(val => matchesLanguageCode(val.languageCode, lang))
        if (!findLangV) {
          findLangV = element?.localization.find(val => matchesLanguageCode(val.languageCode, 'en'))
        }
        if (element.columnType == "STATIC_TEXT") {
          if (!!findLangV) {
            contentHtml += `<td style="border: 1px solid rgb(204, 204, 204); padding: 10px; text-align: left; height: 20px;font-size:14px">${findLangV.text}</td>`
          }
        } else if (element.columnType == "HEADER") {
          if (!!findLangV) {
            contentHtml += `<td style="border: 1px solid rgb(204, 204, 204); padding: 10px; text-align: left; height: 20px;font-size:14px;font-weight:600">${findLangV.text}</td>`
          }
        } else if (element.columnType == "CODE_MAPPING") {
          const findAns = templatedata.keyValues.find(item => item.metadata.columnCode == element.columnCode)
          if (!!findAns) {
            contentHtml += `<td style="border: 1px solid rgb(204, 204, 204); padding: 10px; text-align: left; height: 20px;font-size:14px" class='${findAns.key}'><span style="color: rgb(0, 0, 0);">${qAnserData(findAns)}</span></td>`
          }
        } else {
          if (!!findLangV) {
            contentHtml += `<td style="border: 1px solid rgb(204, 204, 204); padding: 10px; text-align: left; height: 20px;font-size:14px"><span style="color: rgb(0, 0, 0);">${findLangV.text}</span></td>`
          }
        }
      }
    });

    contentHtml += `</tr>`
  }
  contentHtml += `</tbody></table></div>`
  return contentHtml
}


const pagetableTYPE_3Function = (templatedata, lang) => {
  var contentHtml = ''
  let findLangValue = templatedata.localization.find(val => matchesLanguageCode(val.languageCode, lang))
  if (!findLangValue) {
    findLangValue = templatedata.localization.find(val => matchesLanguageCode(val.languageCode, 'en'))
  }
  if (!!findLangValue) {
    contentHtml += `<div style="margin-bottom: 10px;font-size:14px;margin-left: 20px;"><span style="color: rgb(52, 73, 94);"><strong>${findLangValue.text}</strong></span></div>`
  }
  contentHtml += `<div style="margin: 10px 0px;">
  <table style='width:100%;font-size:14px;border-collapse: collapse; border-spacing: 0;'><thead><tr style="background-color: rgb(53, 152, 219); height: 20px;">`
  const columnHeaders = {};
  const filterTopHeader = templatedata.metadata.filter(item => /^[A-Z]1$/.test(item.columnNumber) && item.columnType === "HEADER");
  filterTopHeader.forEach(item => {
    let findLangValue = item.localization.find(val => matchesLanguageCode(val.languageCode, lang))
    if (!findLangValue) {
      findLangValue = item.localization.find(val => matchesLanguageCode(val.languageCode, 'en'))
    }
    if (!!findLangValue) {
      contentHtml += `<th style="border: 1px solid rgb(204, 204, 204); padding: 10px; text-align: left;width:${100 / filterTopHeader.length}%;"><span style="color: rgb(236, 240, 241);">${findLangValue.text}</span></th>`
    }
    columnHeaders[item.columnNumber.replace("1", "")] = item.columnNumber;
  })

  contentHtml += `</tr></thead><tbody>`
  const groupedRows = {};
  const filterBody = templatedata.metadata.filter(meta => !/^[A-Z]1$/.test(meta.columnNumber));
  filterBody.forEach((item) => {
    const col = item?.columnNumber?.charAt(0);
    if (!!col) {
      if (!groupedRows[col]) groupedRows[col] = [];
      groupedRows[col].push(item);
    }
  });
  const maxRows = Math.max(...Object.values(groupedRows).map(arr => arr.length), 0);

  for (let i = 0; i < maxRows; i++) {
    contentHtml += `<tr style="height: 20px;">`

    Object.keys(columnHeaders).forEach(col => {
      const element = groupedRows[col]?.[i]
      if (!!element) {
        let findLangV = element?.localization.find(val => matchesLanguageCode(val.languageCode, lang))
        if (!findLangV) {
          findLangV = element?.localization.find(val => matchesLanguageCode(val.languageCode, 'en'))
        }
        if (element.columnType == "STATIC_TEXT") {
          if (!!findLangV) {
            contentHtml += `<td style="border: 1px solid rgb(204, 204, 204); padding: 10px; text-align: left; height: 20px;font-size:14px">${findLangV.text}</td>`
          }
        } else if (element.columnType == "HEADER") {
          if (!!findLangV) {
            contentHtml += `<td style="border: 1px solid rgb(204, 204, 204); padding: 10px; text-align: left; height: 20px;font-size:14px;font-weight:800">${findLangV.text}</td>`
          }
        } else if (element.columnType == "CODE_MAPPING") {
          const findAns = templatedata.keyValues.filter(item => item.metadata.columnCode == element.columnCode)
          if (!!findAns && findAns.length > 0) {
            findAns.forEach((element1, index) => {
              if (index == 0) {
                contentHtml += `<td style="border: 1px solid rgb(204, 204, 204); padding: 10px; text-align: left; height: 20px;font-size:14px" class='${element1.key}'><span style="color: rgb(0, 0, 0);">${qAnserData(element1)}</span></td>`
              } else {
                contentHtml += `</tr><tr style="height: 20px;"><td style="border: 1px solid rgb(204, 204, 204); padding: 10px; text-align: left; height: 20px;font-size:14px"></td>
                <td style="border: 1px solid rgb(204, 204, 204); padding: 10px; text-align: left; height: 20px;font-size:14px" class='${element1.key}'><span style="color: rgb(0, 0, 0);">${qAnserData(element1)}</span></td>`
              }
            });
          }
        } else {
          if (!!findLangV) {
            contentHtml += `<td style="border: 1px solid rgb(204, 204, 204); padding: 10px; text-align: left; height: 20px;font-size:14px"><span style="color: rgb(0, 0, 0);">${findLangV.text}</span></td>`
          }
        }
      }
    });

    contentHtml += `</tr>`
  }
  contentHtml += `</tbody></table></div>`
  return contentHtml
}

export function pagetableTYPE_5Function(templatedata, lang) {
  let contentHtml = `<div id="typeTableHolder-${templatedata.key}">`;
  let findLangValue = templatedata.localization.find(val => matchesLanguageCode(val.languageCode, lang));
  if (!findLangValue) {
    findLangValue = templatedata.localization.find(val => matchesLanguageCode(val.languageCode, 'en'));
  }
  if (!!findLangValue) {
    contentHtml += `<div style="margin-bottom: 10px;font-size:14px;margin-left: 20px;"><span style=\"color: rgb(52, 73, 94);\"><strong>${findLangValue.text}</strong></span></div>`;
  }

  // Years from baseYear..currentYear inclusive (descending)
  const baseYear = templatedata.baseYear;
  const currentYear = templatedata.currentYear;
  const years = (typeof baseYear === 'number' && typeof currentYear === 'number' && currentYear >= baseYear)
    ? Array.from({ length: currentYear - baseYear + 1 }, (_, i) => currentYear - i)
    : [];

  contentHtml += `<div style="margin: 10px 20px; border: 1px solid #ddd; border-radius: 6px; overflow: hidden;">
  <table style='width:100%;font-size:14px;border-collapse: collapse; border-spacing: 0; border: 1px solid #fff; border-radius: 6px; overflow: hidden;'><tbody>`;

  // Header
  const headerColumns = templatedata.metadata
    .filter(item => /^[A-Z]1$/.test(item.columnNumber) && item.columnType === "HEADER")
    .sort((a, b) => a.columnOrder - b.columnOrder);
  contentHtml += `<tr style="background-color: rgb(241, 247, 249); height: 20px;">`;
  headerColumns.forEach(item => {
    let l = item.localization?.find(val => matchesLanguageCode(val.languageCode, lang));
    if (!l) {
      l = item.localization?.find(val => matchesLanguageCode(val.languageCode, 'en'));
    }
    const headerText = l ? l.text : '';
    contentHtml += `<th style=\"border: 1px solid rgb(204, 204, 204); padding: 10px; text-align: left;font-weight:800;font-size:14px;\"><span style=\"color: rgb(0, 0, 0);\">${headerText}</span></th>`;
  });
  contentHtml += `<th style=\"border: 1px solid rgb(204, 204, 204); padding: 10px; text-align: left;font-weight:800;font-size:14px;\"><span style=\"color: rgb(0, 0, 0);\">UOM</span></th>`;
  years.forEach(y => {
    contentHtml += `<th style=\"border: 1px solid rgb(204, 204, 204); padding: 10px; text-align: left;font-weight:800;font-size:14px;\"><span style=\"color: rgb(0, 0, 0);\">${y}</span></th>`;
  });
  contentHtml += `</tr>`;

  const codeMappingColumns = templatedata.metadata.filter(item => item.columnType === "CODE_MAPPING");

  // Render per metric as a section
  codeMappingColumns.forEach(metricColumn => {
    const metricData = templatedata.keyValues.find(item => item.metadata.columnCode === metricColumn.columnCode);
    if (!metricData) return;

    if (!metricData.metricId) return;

    // Row with metric name
    contentHtml += `<tr style=\"height: 20px; background-color: rgba(44, 192, 106, 0.08);\">`;
    const colNumber = Utils.getColumnNumber(metricColumn.columnNumber);
    for (let i = 1; i <= headerColumns.length; i++) {
      if (i === colNumber) {
        contentHtml += `<td style=\"border: 1px solid rgb(204, 204, 204); padding: 10px; text-align: left;font-size:14px;font-weight:600;\">${metricData.metricName || ''}</td>`;
      } else {
        contentHtml += `<td style=\"border: 1px solid rgb(204, 204, 204);\"></td>`;
      }
    }    
    // UOM data
    contentHtml += `<td style=\"border: 1px solid rgb(204, 204, 204);\"></td>`;
    // Year cells
    years.forEach(() => {
      contentHtml += `<td style=\"border: 1px solid rgb(204, 204, 204);\"></td>`;
    });
    contentHtml += `</tr>`;

    // Build unique branches seen anywhere under this metric; order by businessUnits if provided
    const buOrder = (templatedata.businessUnits || []).map(b => ({ id: b.id, name: b.name }));
    const branchMap = new Map();
    (metricData.periodData || []).forEach(p => (p.branchData || []).forEach(b => branchMap.set(b.branchId || b.branchName, b.branchName)));
    (metricData.datapoints || []).sort((a, b) => a.sortOrder - b.sortOrder).forEach(dp => (dp.periodData || []).forEach(p => (p.branchData || []).forEach(b => branchMap.set(b.branchId || b.branchName, b.branchName))));
    let branches = Array.from(branchMap.entries()).map(([key, name]) => ({ key, name }));
    if (buOrder.length > 0) {
      const indexOf = (br) => {
        const i = buOrder.findIndex(b => b.id === br.key || b.name === br.name);
        return i === -1 ? Number.MAX_SAFE_INTEGER : i;
      }
      branches.sort((a, b) => indexOf(a) - indexOf(b));
    } else {
      branches.sort((a, b) => a.name.localeCompare(b.name));
    }

    branches.forEach(br => {
      const branchName = br.name;
      // Branch aggregate row (from metric totals branchData)
      contentHtml += `<tr style=\"height: 20px;\">`;
      for (let i = 1; i <= headerColumns.length; i++) {
        if (i === colNumber) {
          contentHtml += `<td style=\"border: 1px solid rgb(204, 204, 204); padding: 10px; text-align: left;font-size:14px;font-weight:600;\">${branchName}</td>`;
        } else {
          contentHtml += `<td style=\"border: 1px solid rgb(204, 204, 204);\"></td>`;
        }
      }     
      // Empty cell for UOM
      contentHtml += `<td style=\"border: 1px solid rgb(204, 204, 204);padding: 10px; text-align: left;font-size:14px;font-weight:600;\">${metricData.unitOfMeasure}</td>`;
      years.forEach(y => {
        const p = (metricData.periodData || []).find(pp => new Date(pp.period).getFullYear() === y);
        const v = p ? (p.branchData || []).find(b => (b.branchId === br.key) || (b.branchName === branchName)) : null;
        contentHtml += `<td style=\"border: 1px solid rgb(204, 204, 204); padding: 10px; text-align: left;font-size:14px;\">${v ? (v.value ?? '') : ''}</td>`;
      });
      contentHtml += `</tr>`;

      // Datapoints under this branch
      (metricData.datapoints || []).forEach(dp => {
        contentHtml += `<tr style=\"height: 20px;\">`;
        for (let i = 1; i <= headerColumns.length; i++) {
          if (i === colNumber) {
            contentHtml += `<td style=\"border: 1px solid rgb(204, 204, 204); padding: 10px 10px 10px 30px; text-align: left;font-size:14px;\">${dp.datapointName}</td>`;
          } else {
            contentHtml += `<td style=\"border: 1px solid rgb(204, 204, 204);\"></td>`;
          }
        }        
        // UOM data
        contentHtml += `<td style=\"border: 1px solid rgb(204, 204, 204); padding: 10px; text-align: left;font-size:14px;\">${dp.unitOfMeasure}</td>`;
        //Year data
        years.forEach(y => {
          const p = (dp.periodData || []).find(pp => new Date(pp.period).getFullYear() === y);
          const v = p ? (p.branchData || []).find(b => (b.branchId === br.key) || (b.branchName === branchName)) : null;
          contentHtml += `<td style=\"border: 1px solid rgb(204, 204, 204); padding: 10px; text-align: left;font-size:14px;\">${v ? (v.value ?? '') : ''}</td>`;
        });
        contentHtml += `</tr>`;
      });
    });
  });
  contentHtml += `</tbody></table></div></div>`;
  return contentHtml;
}

const pageHtml = (templateData, lang, type) => {
  if (!!templateData && templateData.length > 0) {
    var htmlContent = ''
    for (let index = 0; index < templateData.length; index++) {
      const element = templateData[index];
      if (element.keyValueType == "PAGE") {
        htmlContent += pageHeaderFunction(element, lang, type)
      }
      if (element.keyValueType == "SECTION") {
        htmlContent += pageSectionFunction(element, lang)
      }
      if (element.keyValueType == "SUB_SECTION") {
        htmlContent += pageSubSectionFunction(element, lang, type)
      }
      if (element.keyValueType == "SINGLE_VALUE") {
        if (!!element.keyValues && element.keyValues.length > 0 && !!qAnserData(element.keyValues[0])) {
          htmlContent += pageQuestionFunction(element, lang)
        }
      }
      if (element.keyValueType == "TYPE_1_TABLE") {
        htmlContent += pagetableTYPE_1Function(element, lang)
      }
      if (element.keyValueType == "TYPE_2_TABLE") {
        htmlContent += pagetableTYPE_2Function(element, lang)
      }
      if (element.keyValueType == "TYPE_3_TABLE") {
        htmlContent += pagetableTYPE_3Function(element, lang)
      }
      if (element.keyValueType == "TYPE_5_TABLE") {
        htmlContent += pagetableTYPE_5Function(element, lang)
      }
    }
    htmlContent += `</div>`
    return htmlContent
  } else {
    return `<div></div>`
  }

}

export default class ESRSReportingUtils {


  static getCoverSection(companyId, year, t, reportData = {}, language, i18n) {
    // Normalize the language code
    const normalizedLang = normalizeLanguageCode(language);
    
    const logoURL = API_ROUTES.PROFILESETTINGS.GETCOMPANYLOGO.replace(
      "<companyId>",
      companyId
    );
    
    // Extract report metadata
    const version = reportData.version || "1";
    const generatedBy = reportData.generatedBy || reportData.companyName || "System";
    const currentDate = reportData.date || new Date().toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: '2-digit', 
      day: '2-digit' 
    }).replace(/\//g, '-');

    const metaTable = buildCoverMetadataTableHtml({
      versionLabel: getTranslation(i18n, "Version.label", language),
      generatedByLabel: getTranslation(i18n, "GeneratedBy.label", language),
      dateLabel: getTranslation(i18n, "Date.label", language),
      version,
      generatedBy,
      currentDate,
    });

    const coverImgSrc = `${process.env.REACT_APP_REPORT_SERVICE_BASE_URL}/esrs/images/Cover-image-1-1280x720.jpg`;
    
    return {
      name: getTranslation(i18n, "FrontCoverpage.label", language),
      index: 0,
      sortOrder: 1,
      type: ReportSection.TITLE,
      pages: [{
        name: getTranslation(i18n, "FrontCoverpage.label", language),
        sortOrder: 1,
        index: 0,
        type: ReportPageType.TITLE,
        html: `
          <div style="page-break-after:always;background-color:#fff;">
            <table cellpadding="0" cellspacing="0" border="0" style="width:100%;border-collapse:collapse;min-height:10.5in;">
              <tr>
                <td style="width:38%;vertical-align:top;padding:0;border:0;">
                  <img src="${coverImgSrc}" alt="" style="width:100%;display:block;height:auto;"/>
                </td>
                <td style="vertical-align:top;padding:28pt 20pt 24pt 20pt;border:0;">
                  <table cellpadding="0" cellspacing="0" border="0" style="width:100%;border-collapse:collapse;">
                    <tr><td align="right" style="padding:0 0 14pt 0;"><img src="${logoURL}" alt="" width="120" style="width:120px;max-width:120px;height:auto;"/></td></tr>
                  </table>
                  <h2 style="font-size:48pt;font-weight:800;color:#0a58ca;margin:0 0 8pt 0;line-height:1.05;">${getTranslation(i18n, "FY.label", language)} ${year}</h2>
                  <h3 style="font-size:26pt;font-weight:700;color:#091a2a;margin:0;line-height:1.15;">${getTranslation(i18n, "EuropeanSustainability.label", language)} <br /> ${getTranslation(i18n, "ReportingStandards.label", language)} <br /> (${getTranslation(i18n, "ESRS.label", language)})</h3>
                  <div style="margin-top:36pt;">${metaTable}</div>
                </td>
              </tr>
            </table>
          </div>
        `,
      }]
    }
  }

  static getTableOfContentsSection(t, language, i18n) {
    const normalizedLang = normalizeLanguageCode(language);
    const L = (key) => escapeTocHtml(getTranslation(i18n, key, normalizedLang));
    const imgBase = `${process.env.REACT_APP_REPORT_SERVICE_BASE_URL}/esrs/images`;

    const tocHtml = buildIconGridTocHtml(L('TableofContents.label'), [
      {
        bg: '#0a58ca',
        iconSrc: `${imgBase}/introduction_icon.png`,
        title: L('Introduction.label'),
        items: [L('Leadershipmessages.label'), L('AbouttheReport.label'), L('AbouttheCompany.label'), L('OurESGApproach.label')],
      },
      {
        bg: '#2dc26b',
        iconSrc: `${imgBase}/environment_icon.png`,
        title: L('Environment.label'),
        items: [
          L('E1ClimateChange.label'),
          L('E2Pollution.label'),
          L('E3Waterandmarineresourse.label'),
          L('E4Biodiversityandecosystems.label'),
          L('E5Resourceuseandcirculareconomy.label'),
        ],
      },
      {
        bg: '#007bff',
        iconSrc: `${imgBase}/social_icon.png`,
        title: L('Social.label'),
        items: [
          L('S1Ownworkforce.label'),
          L('S2Workersinthevaluechain.label'),
          L('S3Affectedcommunities.label'),
          L('S4Consumersandendusers.label'),
        ],
      },
      {
        bg: '#e2b80f',
        iconSrc: `${imgBase}/governance_icon.png`,
        title: L('Governance.label'),
        items: [L('G1Businessconduct.label')],
      },
    ]);
    
    return {
      name: getTranslation(i18n, "TableofContents.label", normalizedLang),
      index: 1,
      sortOrder: 2,
      type: ReportSection.CONTENTS,
      pages: [{
        name: getTranslation(i18n, "TableofContents.label", normalizedLang),
        sortOrder: 1,
        index: 0,
        type: ReportPageType.CONTENTS,
        html: tocHtml,
      }]
    };
  }

  static getLeadershipSection(t, language, i18n) {
    // Normalize the language code
    const normalizedLang = normalizeLanguageCode(language);
    
    return {
      name: getTranslation(i18n, "LeadershipmessagesTips.key0", language),
      index: 2,
      sortOrder: 3,
      type: ReportSection.LEADERSHIP,
      pages: [
        {
          name: getTranslation(i18n, "LeadershipmessagesTips.key2", language),
          index: 0,
          sortOrder: 1,
          type: ReportPageType.OTHERS,
          html: `
          <div style="font-family: Arial, sans-serif;line-height: 1.6;">
            <h4 style="text-align: left;"><span style="font-size: 24px;"><strong><span style="color: rgb(45, 194, 107);">${getTranslation(i18n, "LeadershipmessagesTips.key0", language)}</span></strong></span></h4>
            <p style="font-size: 14px;"><span style="color: rgb(230, 126, 35);"><em>${getTranslation(i18n, "LeadershipmessagesTips.key1", language)}</em></span></p>
            
            <h4 style="text-align: left;"><span style="font-size: 18px;"><strong>${getTranslation(i18n, "LeadershipmessagesTips.key2", language)}</strong></span></h4>
            <p style="font-size: 14px;"><span style="color: rgb(126, 140, 141);"><strong>${getTranslation(i18n, "LeadershipmessagesTips.key3", language)}</strong></span></p>
            <p><img src="${BASE_URL_DOMAIN}/report/Report_image1.webp" alt="" width="100%" height="200"></p>

          </div>`,
        },
        {
          name: getTranslation(i18n, "MessagefromtheChiefSustainabilityOfficer.label", language),
          index: 1,
          sortOrder: 2,
          type: ReportPageType.OTHERS,
          html: `
          <div style="font-family: Arial, sans-serif;line-height: 1.6;">
            <h4 style="text-align: left;"><span style="font-size: 24px;"><strong><span style="color: rgb(45, 194, 107);">${getTranslation(i18n, "LeadershipmessagesTips.key0", language)}</span></strong></span></h4>
            <p style="font-size: 14px;"><span style="color: rgb(230, 126, 35);"><em>${getTranslation(i18n, "LeadershipmessagesTips.key1", language)}</em></span></p>
            
            <h4 style="text-align: left;"><span style="font-size: 18px;"><strong>${getTranslation(i18n, "MessagefromtheChiefSustainabilityOfficer.label", language)}</strong></span></h4>
            <p style="font-size: 14px;"><span style="color: rgb(126, 140, 141);"><strong>${getTranslation(i18n, "LeadershipmessagesTips.key3", language)}</strong></span></p>
            <p><img src="${BASE_URL_DOMAIN}/report/Report_image1.webp" alt="" width="100%" height="200"></p>

          </div>`,
        },

      ]
    }
  }

  static getAboutReportSection(t, language, i18n) {
    // Normalize the language code
    const normalizedLang = normalizeLanguageCode(language);
    
    return {
      name: getTranslation(i18n, "AbouttheReport.label", language),
      index: 3,
      sortOrder: 4,
      type: ReportSection.ABOUT_REPORT,
      pages: [
        {
          name: getTranslation(i18n, "AbouttheReport.key2", language),
          index: 0,
          sortOrder: 1,
          type: ReportPageType.ABOUT_REPORT,
          html: `<div style="font-family: Arial, sans-serif;line-height: 1.6;">
          <h4 style="text-align: left;"><span style="font-size: 24px;"><strong><span style="color: rgb(45, 194, 107);">${getTranslation(i18n, "AbouttheReport.label", language)}</span></strong></span></h4>
          <p style="font-size: 14px;"><span style="color: rgb(230, 126, 35);"><em>${getTranslation(i18n, "AbouttheReport.key1", language)}</em></span></p>
          
          <h4 style="text-align: left;"><span style="font-size: 18px;"><strong>${getTranslation(i18n, "AbouttheReport.key2", language)}</strong></span></h4>
          <p style="font-size: 14px;"><span style="color: rgb(126, 140, 141);"><strong>${getTranslation(i18n, "AbouttheReport.key3", language)}</strong></span></p>
          <p><img src="${BASE_URL_DOMAIN}/report/Report_image3.webp" alt="" width="100%" height="200"></p>
          <p style="font-size: 14px;"></p>
          </div>`,
        },
        {
          name: getTranslation(i18n, "AbouttheReport.key18", language),
          index: 1,
          sortOrder: 2,
          type: ReportPageType.ESG_HIGHLIGHTS,
          html: `<div style="font-family: Arial, sans-serif;line-height: 1.6;">
          <h4 style="text-align: left;"><span style="font-size: 24px;"><strong><span style="color: rgb(45, 194, 107);">${getTranslation(i18n, "AbouttheReport.label", language)}</span></strong></span></h4>
          <p style="font-size: 14px;"><span style="color: rgb(230, 126, 35);"><em>${getTranslation(i18n, "AbouttheReport.key1", language)}</em></span></p>

          <h4 style="text-align: left;"><strong><span style="font-size: 18px;">${getTranslation(i18n, "AbouttheReport.key18", language)}</span></strong></h4>
          <p style="font-size: 14px;"><span style="color: rgb(126, 140, 141);"><strong>${getTranslation(i18n, "AbouttheReport.key3", language)}</strong></span></p>
          </div>`,
        },
      ]
    }
  }

  static getAboutCompanySection(t, language, i18n) {
    // Normalize the language code
    const normalizedLang = normalizeLanguageCode(language);
    
    return {
      name: getTranslation(i18n, "AbouttheCompany.label", language),
      index: 4,
      sortOrder: 5,
      type: ReportSection.ABOUT_COMPANY,
      pages: [
        {
          name: getTranslation(i18n, "AbouttheCompany.key2", language),
          index: 0,
          sortOrder: 1,
          type: ReportPageType.ABOUT_COMPANY,
          html: `<div style="font-family: Arial, sans-serif;line-height: 1.6;">
          <h4 style="text-align: left;"><span style="font-size: 24px;"><strong><span style="color: rgb(45, 194, 107);">${getTranslation(i18n, "AbouttheCompany.label", language)}</span></strong></span></h4>
          <p style="font-size: 14px;"><span style="color: rgb(230, 126, 35);"><em>${getTranslation(i18n, "AbouttheCompany.key1", language)}</em></span></p>
         
          <h4 style="text-align: left;"><span style="font-size: 18px;"><strong>${getTranslation(i18n, "AbouttheCompany.key2", language)}</strong></span></h4>
          <p style="font-size: 14px;"><span style="color: rgb(126, 140, 141);"><strong>${getTranslation(i18n, "AbouttheCompany.key3", language)}</strong></span></p>
          <p><img src="${BASE_URL_DOMAIN}/report/Report_image3.webp" alt="" width="100%" height="200"></p>
          </div>`,
        },
      ]
    }
  }

  static getOurESGApproachSection(t, language, i18n) {
    // Normalize the language code
    const normalizedLang = normalizeLanguageCode(language);
    
    return {
      name: getTranslation(i18n, "OurESGApproach.label", language),
      index: 5,
      sortOrder: 6,
      type: ReportSection.ESG_APPROACH,
      pages: [
        {
          name: getTranslation(i18n, "OurESGApproach.key2", language),
          index: 0,
          sortOrder: 1,
          type: ReportPageType.OTHERS,
          html: `<div style="font-family: Arial, sans-serif;line-height: 1.6;">
          <h4 style="text-align: left;"><span style="font-size: 24px;"><strong><span style="color: rgb(45, 194, 107);">${getTranslation(i18n, "OurESGApproach.label", language)}</span></strong></span></h4>
          <p style="font-size: 14px;"><span style="color: rgb(230, 126, 35);"><em>${getTranslation(i18n, "OurESGApproach.key1", language)}</em></span></p>
          <h4 style="text-align: left;"><span style="font-size: 18px;"><strong>${getTranslation(i18n, "OurESGApproach.key2", language)}</strong></span></h4>
          <p style="font-size: 14px;"><span style="color: rgb(126, 140, 141);"><strong>${getTranslation(i18n, "OurESGApproach.key3", language)}</strong></span></p>
          <p><img src="${BASE_URL_DOMAIN}/report/Report_image3.webp" alt=""  width="100%" height="200"></p>
        
          </div>`,
        },
        {
          name: getTranslation(i18n, "OurESGApproach.key18", language),
          index: 1,
          sortOrder: 2,
          type: ReportPageType.ESG_GOALS,
          html: `<div style="font-family: Arial, sans-serif;line-height: 1.6;">
          <h4 style="text-align: left;"><span style="font-size: 24px;"><strong><span style="color: rgb(45, 194, 107);">${getTranslation(i18n, "OurESGApproach.label", language)}</span></strong></span></h4>
          <p style="font-size: 14px;"><span style="color: rgb(230, 126, 35);"><em>${getTranslation(i18n, "OurESGApproach.key1", language)}</em></span></p>
          <h4 style="text-align: left;"><span style="font-size: 18px;"><strong>${getTranslation(i18n, "OurESGApproach.key18", language)}</strong></span></h4>
          <p style="font-size: 14px;"><span style="color: rgb(126, 140, 141);"><strong>${getTranslation(i18n, "OurESGApproach.key3", language)}</strong></span></p>
          <p><img src="${BASE_URL_DOMAIN}/report/Report_image3.webp" alt=""  width="100%" height="200"></p>
          
          </div>`,
        },
      ]
    }
  }

  static getGeneralDisclosureSection({ disclosureData, doubleMatReport, language, t, i18n }) {
    // Normalize the language code
    const normalizedLang = normalizeLanguageCode(language);
    
    let htmlContent = pageHtml(disclosureData, normalizedLang, 'GeneralDisclosure');
    doubleMatReport?.sections?.sort((a, b) => {
      return a.sortOrder - b.sortOrder;
    })?.forEach((section, sIndex) => {
      if (sIndex < 2) return;

      section.pages?.sort((a, b) => {
        return a.sortOrder - b.sortOrder;
      });
      section.pages?.forEach(page => {
        const decodedHTML = page.htmlContent ? decodeURIComponent(escape(window.atob(page.htmlContent))) : null;
        htmlContent += `<br/><br/>`;
        htmlContent += decodedHTML ? decodedHTML : null;
      });
    });
    return {
      name: getTranslation(i18n, "GeneralDisclosures.label", language),
      index: 6,
      sortOrder: 7,
      type: ReportSection.GENERAL_DISCLOSURE,
      pages: [
        {
          name: getTranslation(i18n, "GeneralDisclosures.label", language),
          index: 0,
          sortOrder: 1,
          type: ReportPageType.GENERAL_DISCLOSURE,
          html: htmlContent,
        },
      ]
    }
  }

  static getEnvironmentSection(e1Data, e2Data, e3Data, e4Data, e5Data, language, t, i18n) {
    // Normalize the language code
    const normalizedLang = normalizeLanguageCode(language);
    
    const pages = [{
      name: getTranslation(i18n, 'Overview.label', language),
      index: 0,
      sortOrder: 1,
      type: ReportPageType.ENV_OVERVIEW,
      html: `<div style="font-family: Arial, sans-serif; padding: 20px; background-color: #fff; color: #333; line-height: 1.6;">
      <div style="position: relative;padding: 10px 0px;z-index: 1;color: #fff; margin: 0;border-top-left-radius: 50px;border-bottom-left-radius: 50px;display:none;">
        <div
            style="content: '';position: absolute;left: 0;background-color: #2dc26b;right: 54%;height: 100%;top: 0;margin-left: -52px;z-index: 0;border-top-right-radius: 50px;border-bottom-right-radius: 50px;">
          </div>
          <h3 style="color: #fff;margin: 0; position: relative;z-index: 1;">
              ${getTranslation(i18n, 'Environment.label', language)}
          </h3>
      </div>
      <table width="50.5%" style="border-collapse: collapse;margin-left: -52px;table-layout: fixed;page-break-inside: avoid;">
        <tr>
          <td style="background-color: #2dc26b; padding: 10px; border-top-right-radius: 50px; border-bottom-right-radius: 50px; color: white; font-weight: bold;white-space: nowrap;">
            <h3 style="margin: 0px 0px 0px 42px;">${getTranslation(i18n, 'Environment.label', language)}</h3>
          </td>
        </tr>
      </table>
      <div style="padding: 20px;">
          <h2 style="font-size: 14px; font-weight: bold; margin-bottom: 10px;">${getTranslation(i18n, 'E1ClimateChange.label', language)}</h2>
          <h2 style="font-size: 14px; font-weight: bold; margin-bottom: 10px;">${getTranslation(i18n, 'E2Pollution.label', language)}</h2>
          <h2 style="font-size: 14px; font-weight: bold; margin-bottom: 10px;">${getTranslation(i18n, 'E3Waterandmarineresourse.label', language)}</h2>
          <h2 style="font-size: 14px; font-weight: bold; margin-bottom: 10px;">${getTranslation(i18n, 'E4Biodiversityandecosystems.label', language)}</h2>
          <h2 style="font-size: 14px; font-weight: bold; margin-bottom: 10px;">${getTranslation(i18n, 'E5Resourceuseandcirculareconomy.label', language)}</h2>
      </div>
  </div>`,
    }]
    if (e1Data.length > 0 && e1Data.some(item => allowedTypes.includes(item.keyValueType) && (item.keyValueType !== 'SINGLE_VALUE' || (item.keyValues.length > 0 && !!item.keyValues[0].value)))) {
      pages.push({
        name: getTranslation(i18n, 'E1ClimateChange.label', language),
        index: 1,
        sortOrder: 2,
        type: ReportPageType.E1,
        html: pageHtml(e1Data, normalizedLang, 'Environment'),
      })
    }
    if (e2Data.length > 0 && e2Data.some(item => allowedTypes.includes(item.keyValueType) && (item.keyValueType !== 'SINGLE_VALUE' || (item.keyValues.length > 0 && !!item.keyValues[0].value)))) {
      pages.push({
        name: getTranslation(i18n, 'E2Pollution.label', language),
        index: 2,
        sortOrder: 3,
        type: ReportPageType.E2,
        html: pageHtml(e2Data, normalizedLang, 'Environment'),
      })
    }
    if (e3Data.length > 0 && e3Data.some(item => allowedTypes.includes(item.keyValueType) && (item.keyValueType !== 'SINGLE_VALUE' || (item.keyValues.length > 0 && !!item.keyValues[0].value)))) {
      pages.push({
        name: getTranslation(i18n, 'E3Waterandmarineresourse.label', language),
        index: 3,
        sortOrder: 4,
        type: ReportPageType.E3,
        html: pageHtml(e3Data, normalizedLang, 'Environment'),
      })
    }
    if (e4Data.length > 0 && e4Data.some(item => allowedTypes.includes(item.keyValueType) && (item.keyValueType !== 'SINGLE_VALUE' || (item.keyValues.length > 0 && !!item.keyValues[0].value)))) {
      pages.push({
        name: getTranslation(i18n, 'E4Biodiversityandecosystems.label', language),
        index: 4,
        sortOrder: 5,
        type: ReportPageType.E4,
        html: pageHtml(e4Data, normalizedLang, 'Environment'),
      })
    }
    if (e5Data.length > 0 && e5Data.some(item => allowedTypes.includes(item.keyValueType) && (item.keyValueType !== 'SINGLE_VALUE' || (item.keyValues.length > 0 && !!item.keyValues[0].value)))) {
      pages.push({
        name: getTranslation(i18n, 'E5Resourceuseandcirculareconomy.label', language),
        index: 5,
        sortOrder: 6,
        type: ReportPageType.E5,
        html: pageHtml(e5Data, normalizedLang, 'Environment'),
      })
    }
    return {
      name: getTranslation(i18n, 'Environment.label', language),
      index: 7,
      sortOrder: 8,
      type: ReportSection.ENVIRONMENT,
      pages: pages
    }
  }

  static getSocialSection(s1Data, s2Data, s3Data, s4Data, language, t, i18n) {
    // Normalize the language code
    const normalizedLang = normalizeLanguageCode(language);

    const pages = [{
      name: getTranslation(i18n, 'Overview.label', language),
      index: 0,
      sortOrder: 1,
      type: ReportPageType.SOCIAL_OVERVIEW,
      html: `<div style="font-family: Arial, sans-serif; padding: 20px; background-color: #fff; color: #333; line-height: 1.6;">
        <div
          style="position: relative;padding: 10px 0px;z-index: 1;color: #fff; margin: 0;border-top-left-radius: 50px;border-bottom-left-radius: 50px;display:none;">
          <div
              style="content: '';position: absolute;left: 0;background-color: #007bff;right: 54%;height: 100%;top: 0;margin-left: -52px;z-index: 0;border-top-right-radius: 50px;border-bottom-right-radius: 50px;">
          </div>
          <h3 style="color: #fff;margin: 0; position: relative;z-index: 1;">
              ${getTranslation(i18n, 'Social.label', language)}
          </h3>
      </div>
      <table width="50.5%" style="border-collapse: collapse;margin-left: -52px;table-layout: fixed;page-break-inside: avoid;">
        <tr>
          <td style="background-color: #007bff; padding: 10px; border-top-right-radius: 50px; border-bottom-right-radius: 50px; color: white; font-weight: bold;white-space: nowrap;">
            <h3 style="margin: 0px 0px 0px 42px;">${getTranslation(i18n, 'Social.label', language)}</h3>
          </td>
        </tr>
      </table>
      <div style="padding: 20px;">
          <h2 style="font-size: 14px; font-weight: bold; margin-bottom: 10px;">${getTranslation(i18n, "S1Ownworkforce.label", language)}</h2>
          <h2 style="font-size: 14px; font-weight: bold; margin-bottom: 10px;">${getTranslation(i18n, "S2Workersinthevaluechain.label", language)}</h2>
          <h2 style="font-size: 14px; font-weight: bold; margin-bottom: 10px;">${getTranslation(i18n, "S3Affectedcommunities.label", language)}</h2>
          <h2 style="font-size: 14px; font-weight: bold; margin-bottom: 10px;">${getTranslation(i18n, "S4Consumersandendusers.label", language)}</h2>
      </div>
  </div>`,
    }]
    if (s1Data.length > 0 && s1Data.some(item => allowedTypes.includes(item.keyValueType) && (item.keyValueType !== 'SINGLE_VALUE' || (item.keyValues.length > 0 && !!item.keyValues[0].value)))) {
      pages.push({
        name: getTranslation(i18n, 'S1Ownworkforce.label', language),
        index: 1,
        sortOrder: 2,
        type: ReportPageType.S1,
        html: pageHtml(s1Data, normalizedLang, 'Social'),
      },)
    }
    if (s2Data.length > 0 && s2Data.some(item => allowedTypes.includes(item.keyValueType) && (item.keyValueType !== 'SINGLE_VALUE' || (item.keyValues.length > 0 && !!item.keyValues[0].value)))) {
      pages.push({
        name: getTranslation(i18n, 'S2Workersinthevaluechain.label', language),
        index: 2,
        sortOrder: 3,
        type: ReportPageType.S2,
        html: pageHtml(s2Data, normalizedLang, 'Social')
      })
    }
    if (s3Data.length > 0 && s3Data.some(item => allowedTypes.includes(item.keyValueType) && (item.keyValueType !== 'SINGLE_VALUE' || (item.keyValues.length > 0 && !!item.keyValues[0].value)))) {
      pages.push({
        name: getTranslation(i18n, 'S3Affectedcommunities.label', language),
        index: 3,
        sortOrder: 4,
        type: ReportPageType.S3,
        html: pageHtml(s3Data, normalizedLang, 'Social'),
      })
    }
    if (s4Data.length > 0 && s4Data.some(item => allowedTypes.includes(item.keyValueType) && (item.keyValueType !== 'SINGLE_VALUE' || (item.keyValues.length > 0 && !!item.keyValues[0].value)))) {
      pages.push({
        name: getTranslation(i18n, 'S4Consumersandendusers.label', language),
        index: 4,
        sortOrder: 5,
        type: ReportPageType.S4,
        html: pageHtml(s4Data, normalizedLang, 'Social'),
      })
    }
    return {
      name: getTranslation(i18n, 'Social.label', language),
      index: 8,
      sortOrder: 9,
      type: ReportSection.SOCIAL,
      pages: pages
    }
  }

  static getGovernanceSection(g1Data, language, t, i18n) {
    // Normalize the language code
    const normalizedLang = normalizeLanguageCode(language);
    
    const pages = [
      {
        name: getTranslation(i18n, 'Overview.label', normalizedLang),
        index: 0,
        sortOrder: 1,
        type: ReportPageType.GOV_OVERVIEW,
        html: `<div style="font-family: Arial, sans-serif; padding: 20px; background-color: #fff; color: #333; line-height: 1.6;">
        <div
          style="position: relative;padding: 10px 0px;z-index: 1;color: #fff; margin: 0;border-top-left-radius: 50px;border-bottom-left-radius: 50px;display:none;">
          <div
              style="content: '';position: absolute;left: 0;background-color: #f7c300;right: 54%;height: 100%;top: 0;margin-left: -52px;z-index: 0;border-top-right-radius: 50px;border-bottom-right-radius: 50px;">
          </div>
          <h3 style="color: #fff;margin: 0; position: relative;z-index: 1;">
              ${getTranslation(i18n, 'Governance.label', normalizedLang)}
          </h5>
        </div>
        <table width="50.5%" style="border-collapse: collapse;margin-left: -52px;table-layout: fixed;page-break-inside: avoid;">
          <tr>
            <td style="background-color: #f7c300; padding: 10px; border-top-right-radius: 50px; border-bottom-right-radius: 50px; color: white; font-weight: bold;white-space: nowrap;">
              <h3 style="margin: 0px 0px 0px 42px;">${getTranslation(i18n, 'Governance.label', normalizedLang)}</h3>
            </td>
          </tr>
        </table>
        <div style="padding: 20px;">
        <h2 style="font-size: 14px; font-weight: bold; margin-bottom: 10px;">${getTranslation(i18n, "G1Businessconduct.label", normalizedLang)}</h2>
    </div>
    </div>`,
      }]
    if (g1Data.length > 0 && g1Data.some(item => allowedTypes.includes(item.keyValueType) && (item.keyValueType !== 'SINGLE_VALUE' || (item.keyValues.length > 0 && !!item.keyValues[0].value)))) {
      pages.push({
        name: getTranslation(i18n, 'G1Businessconduct.label', normalizedLang),
        index: 1,
        sortOrder: 2,
        type: ReportPageType.G1,
        html: pageHtml(g1Data, normalizedLang, 'Governance'),
      })
    }
    return {
      name: getTranslation(i18n, 'Governance.label', normalizedLang),
      index: 9,
      sortOrder: 10,
      type: ReportSection.GOVERNANCE,
      pages: pages
    }
  }

  static getBackCover(companyId, year, t, language, i18n) {
    // Normalize the language code
    const normalizedLang = normalizeLanguageCode(language);
    
    const logoURL = API_ROUTES.PROFILESETTINGS.GETCOMPANYLOGO.replace(
      "<companyId>",
      companyId
    );
    return {
      name: getTranslation(i18n, "Root.label", language),
      index: 10,
      sortOrder: 11,
      type: ReportSection.ROOT,
      pages: [
        {
          name: getTranslation(i18n, "BackCover.key0", language),
          sortOrder: 0,
          index: 1,
          type: ReportPageType.ROOT,
          html: `<div style="position: relative; overflow: hidden; background-color: #fff; page-break-after: always; height: calc(100vh - 107px);">
          <div style="overflow: hidden; height: 100%; width: 50%; position: relative; left: 50%; overflow: hidden;">
            <div style="content: ''; background-color: rgba(23, 96, 166, 0.78); position: absolute; left: 0px; width: 60px; top: 0px; bottom: 0px;"></div>
            <div style="content: ''; background-color: rgba(242, 183, 20, 0.78); position: absolute; left: 60px; width: 60px; top: 0px; bottom: 0px;"></div>
            <img src='${process.env.REACT_APP_REPORT_SERVICE_BASE_URL}/esrs/images/Cover-image-1-1280x720.jpg' alt="Cover" style="max-width: fit-content; height: 100%;" />
          </div>
          <div style="position: absolute; top: 0px; left: 0px; bottom: 0px; z-index: 1; right: 37rem; padding: 6rem 5rem; display: flex; align-items: center;">
            <div style="position: absolute; top: 40px; left: 40px; width: 140px;">
              <img src=${logoURL} alt="Company Logo" style="width: 100%;" />
            </div>
            <div>
              <h2 style="font-size: 72px; font-weight: 800; color: #0a58ca; margin-bottom: 0px;">${getTranslation(i18n, "FY.label", language)} ${year}</h2>
              <h3 style="font-size: 44px; font-weight: 700; color: #091a2a;">${getTranslation(i18n, "EuropeanSustainability.label", language)} <br /> ${getTranslation(i18n, "ReportingStandards.label", language)} <br /> (${getTranslation(i18n, "ESRS.label", language)})</h3>
            </div>
            <div style="position: absolute; bottom: 40px; left: 40px;">
            </div>
          </div>
        </div>`,
        },
      ]
    };
  }
}
